var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplaintSolidStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 11.75C4 9.95507 5.45507 8.5 7.25 8.5C9.04493 8.5 10.5 9.95507 10.5 11.75C10.5 13.5449 9.04493 15 7.25 15C5.45507 15 4 13.5449 4 11.75ZM1 21.75C1 18.5087 3.86708 16 7.25 16C10.6329 16 13.5 18.5087 13.5 21.75C13.5 22.1642 13.1642 22.5 12.75 22.5H1.75C1.33579 22.5 1 22.1642 1 21.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.75 1C13.6063 1 11 3.44659 11 6.53335C11 8.01184 11.6034 9.35104 12.5752 10.3381C12.5912 10.3544 12.6271 10.4074 12.6271 10.4074C12.5652 10.7108 12.4325 10.9909 12.2435 11.2235C12.0766 11.4288 12.0303 11.7069 12.1216 11.9553C12.2129 12.2036 12.4283 12.3855 12.6885 12.4339C13.5791 12.5995 14.5008 12.4499 15.29 12.0302C15.3731 11.986 15.4309 11.9553 15.4744 11.9331C15.5145 11.9402 15.5859 11.9533 15.6442 11.9643C16.0087 12.0327 16.3786 12.0671 16.75 12.0667C19.8936 12.0667 22.5 9.6201 22.5 6.53335C22.5 3.44658 19.8936 1 16.75 1ZM17.5084 4.75C17.5084 4.33579 17.1726 4 16.7584 4C16.3442 4 16.0084 4.33579 16.0084 4.75V6.74999C16.0084 7.1642 16.3442 7.49999 16.7584 7.49999C17.1726 7.49999 17.5084 7.1642 17.5084 6.74999V4.75ZM16.75 7.99998C16.3358 7.99998 16 8.33577 16 8.74998C16 9.1642 16.3358 9.49998 16.75 9.49998H16.7581C17.1723 9.49998 17.5081 9.1642 17.5081 8.74998C17.5081 8.33577 17.1723 7.99998 16.7581 7.99998H16.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplaintSolidStandard);
export default __webpack_public_path__ + "static/media/complaint-solid-standard.00af8bd3dd2e974bbf28d86017130d50.svg";
export { ForwardRef as ReactComponent };